export const MENU = {
  HOME: 'home',
  BROADCAST: 'broadcast',
  LIVE: 'live',
  LIVE_NEW: 'live_new',
  MOVIE: 'movie',
  GLOBAL: 'global',
  PLAYY: 'palyy',
  CLIP: 'clip',
  LIST: 'list',
  MOVIE_17: 'movie_17',
  MOVIE_18: 'movie_18',
  BASEBALL: 'baseball',
  CATEGORY: 'category',
  MY: 'my',
}
export const ON_DISPLAY_BAND = 'on_display_multi_band'
export const STORAGE_ROUTER_HISTORY = 'router_history'
export const STORAGE_TRANSACTION_KEY = 'transaction_key'
export const STORAGE_ROUTER_BACK_ADDRESS = 'router_back_address'
export const STORAGE_CONTENT_FROM_SEARCH = 'content_from_search'

export const DEVICE_TYPE = new Map([
  ['pc', 1],
  ['mobile', 8],
])

// 계정 연결을 위한 provider 목록
export const PROVIDER_LIST = [
  {
    id: 1,
    type: 'wavve',
    title: 'Wavve',
  },
  {
    id: 15,
    type: 'facebook',
    title: 'Facebook',
  },
  {
    id: 16,
    type: 'kakao',
    title: 'Kakao',
  },
  {
    id: 17,
    type: 'naver',
    title: 'Naver',
  },
  {
    id: 20,
    type: 'tid',
    title: 'T-ID',
  },
  {
    id: 21,
    type: 'apple',
    title: 'Apple',
  },
]

export const CONSENT_PROMOTION_LAYER_POPUP = 'CONSENT_PROMOTION_LAYER_POPUP'
export const FIRST_MONTH_PROMOTION_LAYER_POPUP = 'FIST_MONTH_PROMOTION_POPUP'

export const FIRST_MONTH_PROMOTION_CONFIRM = 'FIRST_MONTH_PROMOTION_CONFIRM'

export const POPUP_STANDARD = 'POPUP_STANDARD'
export const POPUP_STANDARD_CONFIRM = 'POPUP_STANDARD_CONFIRM'
